<template>
  <div class="wrap-history">
    <div
      class="content"
      v-for="item in list"
      :key="item.id"
      @click="handleHref(item.isHref, item.url)"
    >
      <div class="left">
        <img class="img" src="./pdf.png" alt="" />
      </div>
      <div class="right">
        <div class="top-text">{{ item.title }}</div>
        <div class="bottom-text">{{ item.date }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HisTory',
  data() {
    return {
      list: [
        // {
        //   id: 1,
        //   title: '爱奇艺服务协议',
        //   date: '2020年9月版本',
        //   isHref: true,
        //   url:
        //     'https://www.iqiyi.com/common/showLegalhistory.html?social_platform=link&p1=2_22_221&order=1'
        // },
        // {
        //   id: 2,
        //   title: '爱奇艺知识用户协议',
        //   date: '2021年9月版本',
        //   isHref: false,
        //   url: '/historyList/word'
        // },
        // {
        //   id: 3,
        //   title: '爱奇艺隐私政策',
        //   date: '2020年9月版本',
        //   isHref: true,
        //   url:
        //     'https://www.iqiyi.com/common/showLegalhistory.html?social_platform=link&p1=2_22_221&order=2'
        // },
        // {
        //   id: 4,
        //   title: '爱奇艺隐私政策',
        //   date: '2021年9月版本',
        //   isHref: true,
        //   url:
        //     'https://www.iqiyi.com/common/showLegalhistory.html?social_platform=link&p1=2_22_221&order=3'
        // },
        // {
        //   id: 5,
        //   title: '爱奇艺隐私政策',
        //   date: '2021年11月版本',
        //   isHref: true,
        //   url:
        //     'https://www.iqiyi.com/common/showLegalhistory.html?social_platform=link&p1=2_22_221&order=4'
        // },
        // {
        //   id: 6,
        //   title: '爱奇艺遍知隐私政策',
        //   date: '2022年7月版本',
        //   isHref: true,
        //   url: 'https://static.iqiyi.com/kpp/static/iqiyi-bianzhi-private-202207.html'
        // },
        // {
        //   id: 6,
        //   title: '爱奇艺遍知隐私政策',
        //   date: '2022年7月版本',
        //   isHref: false,
        //   url: '/historyList/seven'
        // },
        // {
        //   id: 7,
        //   title: '爱奇艺遍知隐私政策',
        //   date: '2023年2月版本',
        //   isHref: true,
        //   url: 'https://static.iqiyi.com/kpp/static/iqiyi-bianzhi-private-202303.html'
        // },
        // {
        //   id: 7,
        //   title: '爱奇艺遍知隐私政策',
        //   date: '2023年2月版本',
        //   isHref: false,
        //   url: '/historyList/two'
        // },
        // {
        //   id: 8,
        //   title: '爱奇艺遍知隐私政策',
        //   date: '2023年3月版本',
        //   isHref: true,
        //   url: 'https://static.iqiyi.com/kpp/static/iqiyi-bianzhi-private-20230308.html'
        // },
        // {
        //   id: 8,
        //   title: '爱奇艺遍知隐私政策',
        //   date: '2023年3月版本',
        //   isHref: false,
        //   url: '/historyList/three'
        // },
        // {
        //   id: 9,
        //   title: '爱奇艺遍知隐私政策',
        //   date: '2023年3月31日版本',
        //   isHref: true,
        //   url: 'https://static.iqiyi.com/kpp/static/iqiyi-bianzhi-private-20230331.html'
        // },
        // {
        //   id: 9,
        //   title: '爱奇艺遍知隐私政策',
        //   date: '2023年3月31日版本',
        //   isHref: false,
        //   url: '/historyList/three-31'
        // },
        // {
        //   id: 15,
        //   title: '爱奇艺遍知隐私政策',
        //   date: '2023年4月27日版本',
        //   isHref: false,
        //   url: '/historyList/recent-private'
        // },

        // {
        //   id: 10,
        //   title: '配音课程服务协议v1',
        //   date: '2022年3月版本',
        //   isHref: true,
        //   url: 'https://static-d.iqiyi.com/lequ/pinzhidake/配音课程服务协议v1.html'
        // },
        {
          id: 11,
          title: '配音课程服务协议',
          date: '2021年11月版本',
          isHref: true,
          url: 'https://static-d.iqiyi.com/lequ/pinzhidake/配音课程服务协议v2.html'
        },
        // {
        //   id: 11,
        //   title: '配音课程服务协议',
        //   date: '2021年11月版本',
        //   isHref: false,
        //   url: '/historyList/peiyin'
        // },
        // {
        //   id: 12,
        //   title: 'AIGC课程服务协议',
        //   date: '2023年9月版本',
        //   isHref: false,
        //   url: '/historyList/aigc'
        // },
        {
          id: 13,
          title: '配音课程服务协议-商单',
          date: '2023年12月版本',
          isHref: false,
          url: '/history-list/course-agreement-2023-12'
        },
        {
          id: 14,
          title: '配音课程服务协议-4.0版本',
          date: '',
          isHref: false,
          url: '/history-list/course-agreement-v4'
        },
        {
          id: 16,
          title: '配音课程服务协议-4.0版本',
          date: '2024年6月版本',
          isHref: false,
          url: '/history-list/course-agreement-v4-2024-6'
        }
        // {
        //   // 与产品&项目确认，此政策端上正在使用，h5更换其内容，链接不变 历史中不显示最新版本
        //   id: 9,
        //   title: '爱奇艺遍知隐私政策',
        //   date: '2023年3月31日版本',
        //   isHref: true,
        //   url: 'https://static.iqiyi.com/kpp/static/iqiyi-bianzhi-private-202209.html'
        // }
      ]
    }
  },

  methods: {
    handleHref(isHref, href) {
      if (isHref) {
        location.href = href
        return
      }
      this.$router.push(href)
    }
  }
}
</script>
<style lang="less" scoped>
.wrap-history {
  padding: 14px;
  .content {
    display: flex;
    align-items: center;
    padding-bottom: 25px;
    .left {
      width: 50px;
      height: 50px;
      margin-right: 2vw;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      .top-text {
        font-size: 16px;
        color: #040f26;
      }
      .bottom-text {
        font-size: 12px;
        color: #6d7380;
      }
    }
  }
}
</style>
